module.exports = __webpack_public_path__ + "static/media/ilights_rgb.40d25fa7.svg";